module.exports = __webpack_public_path__ + "static/media/mini-dumper.f591fed8.jpg";